"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.scan = exports.Scanner = exports.SyntaxError = void 0;
const token_1 = require("./token");
const token_type_1 = require("./token_type");
class SyntaxError extends Error {
    constructor(message, line, start, end) {
        super(message);
        this.line = line;
        this.start = start;
        this.end = end;
    }
}
exports.SyntaxError = SyntaxError;
class Scanner {
    constructor(source, { safe = false } = {}) {
        this.source = source;
        this.tokens = [];
        this.start = 0;
        this.current = 0;
        this.line = 1;
        /**
         * If `true`, then scanner will not throw on unexpected characters and packs them into a token of `TokenType.Unknown`
         * type. Safe mode is useful for syntax highlighting where we want the scanner to succeed even on invalid syntax.
         */
        this.safe = false;
        this.source = source;
        this.safe = safe;
    }
    scanTokens() {
        while (!this.isAtEnd()) {
            this.start = this.current;
            this.scanToken();
        }
        this.appendToken(new token_1.Token(token_type_1.TokenType.EOF, '', null, this.line, this.start, this.current));
        return this.tokens;
    }
    scanToken() {
        const c = this.advance();
        switch (c) {
            case '(':
                this.addToken(token_type_1.TokenType.LeftParen);
                break;
            case ')':
                this.addToken(token_type_1.TokenType.RightParen);
                break;
            case ',':
                this.addToken(token_type_1.TokenType.Comma);
                break;
            case '.':
                this.addToken(token_type_1.TokenType.Period);
                break;
            case ' ':
            case '\r':
            case '\t':
            case '\n':
                this.whitespace();
                break;
            case `'`:
            case '"':
                this.string(c);
                break;
            case '-':
            default:
                if (this.isDigit(c) || (c === '-' && this.isDigit(this.peek()))) {
                    this.number();
                }
                else if (this.isAlpha(c)) {
                    this.identifierOrKeyword();
                }
                else if (this.safe) {
                    this.addToken(token_type_1.TokenType.Unknown);
                }
                else {
                    throw new SyntaxError(`Unexpected character ${c}`, this.line, this.current - 1, this.current);
                }
        }
    }
    isAtEnd() {
        return this.current >= this.source.length;
    }
    advance() {
        this.current += 1;
        return this.source[this.current - 1];
    }
    addToken(type, literal = null) {
        const text = this.source.substring(this.start, this.current);
        this.appendToken(new token_1.Token(type, text, literal, this.line, this.start, this.current));
    }
    appendToken(token) {
        this.tokens[this.tokens.length - 1]?.setNext(token);
        this.tokens.push(token);
    }
    peek() {
        if (this.isAtEnd()) {
            return '\0';
        }
        return this.source[this.current];
    }
    peekNext() {
        if (this.current + 1 >= this.source.length) {
            return '\0';
        }
        return this.source[this.current + 1];
    }
    peekPrevious() {
        if (this.current - 1 < 0) {
            return '\0';
        }
        return this.source[this.current - 1];
    }
    string(limiter = '"') {
        while ((this.peek() !== limiter || (this.peek() === limiter && this.peekPrevious() === '\\')) && !this.isAtEnd()) {
            if (this.peek() === '\n') {
                this.line += 1;
            }
            this.advance();
        }
        if (this.isAtEnd() && !this.safe) {
            throw new SyntaxError('Unterminated string', this.line, this.start, this.current);
        }
        // Safeguard for the situation where this.safe is set to true. If string is left unterminated, we'll report
        // incorrect end position. For example, on input `prop("Foo`.
        if (!this.isAtEnd()) {
            this.advance();
        }
        const value = this.source.substring(this.start + 1, this.current - 1);
        this.addToken(token_type_1.TokenType.String, value);
    }
    number() {
        while (this.isDigit(this.peek())) {
            this.advance();
        }
        if (this.peek() === '.' && this.isDigit(this.peekNext())) {
            this.advance();
            while (this.isDigit(this.peek())) {
                this.advance();
            }
        }
        const value = this.source.substring(this.start, this.current);
        this.addToken(token_type_1.TokenType.Number, parseFloat(value));
    }
    isDigit(c) {
        return c >= '0' && c <= '9';
    }
    isAlpha(c) {
        return (c >= 'a' && c <= 'z') || (c >= 'A' && c <= 'Z') || c === '_';
    }
    isAlphaNumeric(c) {
        return this.isAlpha(c) || this.isDigit(c);
    }
    identifierOrKeyword() {
        while (this.isAlphaNumeric(this.peek())) {
            this.advance();
        }
        const text = this.source.substring(this.start, this.current);
        if (text === 'null') {
            this.addToken(token_type_1.TokenType.Null, null);
        }
        else if (text === 'true') {
            this.addToken(token_type_1.TokenType.True, true);
        }
        else if (text === 'false') {
            this.addToken(token_type_1.TokenType.False, false);
        }
        else {
            this.addToken(token_type_1.TokenType.Identifier);
        }
    }
    isWhitespace(c) {
        return c === ' ' || c === '\r' || c === '\t' || c === '\n';
    }
    whitespace() {
        while (this.isWhitespace(this.peek())) {
            const char = this.advance();
            if (char === '\n') {
                this.line += 1;
            }
        }
        this.addToken(token_type_1.TokenType.Whitespace);
    }
}
exports.Scanner = Scanner;
const scan = (source) => new Scanner(source).scanTokens();
exports.scan = scan;
//# sourceMappingURL=scanner.js.map